import { render, staticRenderFns } from "./help-hero.vue?vue&type=template&id=32016cdf&scoped=true"
import script from "./help-hero.vue?vue&type=script&lang=js"
export * from "./help-hero.vue?vue&type=script&lang=js"
import style0 from "./help-hero.vue?vue&type=style&index=0&id=32016cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32016cdf",
  null
  
)

export default component.exports